import { useEffect, useRef } from 'react';

import { GearbeltEvent } from '@gearbelt/global';
import { Outlet } from 'react-router';
import { useLocation, useSearchParams } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { SSORedirectionModal } from '@/pages/signup/signup-redirection-modal';
import { WorkspaceBrandingStep } from '@/pages/signup/workspace-branding.step';
import { WorkspaceSetupWelcomeModal } from '@/pages/workspace-setup/workspace-setup-welcome-modal';
import { useCollapsibleNavbarStore } from '@/stores/collapsible-navbar.store';
import { getForceLogoutFlagForSSOSignUp } from '@/utils/auth';
import { useEvents } from '@/utils/events';

import { Topbar } from '../topbar/topbar';
import WorkspaceSwitcherModal from '../workspace-switcher/workspace-switcher-modal';
import WorkspaceSwitcherUpgradePlanModal from '../workspace-switcher/workspace-switcher-upgrade-plan-modal';
import { ExpiredTrialModal } from '../workspace/expired-trial-modal';
import { Sidebar } from './sidebar';

const DefaultLayout = () => {
  const [searchParams] = useSearchParams();
  const isInSSOSignUpFlow = searchParams.get('isSSOSignup');
  const forceLogoutFlag = getForceLogoutFlagForSSOSignUp();
  const shouldShowRedirectionModal = forceLogoutFlag === 'true' && !isInSSOSignUpFlow;
  const { isSidebarOpen } = useCollapsibleNavbarStore();
  const { pathname } = useLocation();
  const { trackEvent } = useEvents();
  const trackEventRef = useRef(trackEvent);
  trackEventRef.current = trackEvent;

  useEffect(() => {
    trackEventRef.current(GearbeltEvent.GBWPageViewed);
  }, [pathname]);

  return (
    <>
      <ExpiredTrialModal />
      <WorkspaceBrandingStep />
      <WorkspaceSetupWelcomeModal />
      {shouldShowRedirectionModal && <SSORedirectionModal />}

      <WorkspaceSwitcherModal />
      <WorkspaceSwitcherUpgradePlanModal />
      <div
        className={cn(
          'bg-default-text grid min-h-0 flex-1 grid-rows-[58px_auto] overflow-hidden',
          isSidebarOpen ? 'grid-cols-[260px_auto]' : 'grid-cols-[51px_auto]',
        )}>
        <aside className="row-span-2">
          <Sidebar />
        </aside>

        <header>
          <Topbar />
        </header>

        <main className="bg-grey-1 relative flex flex-col overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default DefaultLayout;
